export default __webpack_public_path__ + "static/media/CalcGenius.65e37a6be1a9ca3812b8eec53ddc5389.webp";